export default __webpack_public_path__ + "static/media/AQR-token.f7385d6e.png";